import { toast } from "react-toastify";
import { HTTPURL } from "../constants/Matcher";

const base = `${HTTPURL}api`;

// URLSearchParams serializes undefined as the string "undefined" — strip
// empty values before constructing the query.
const toQs = (params) => {
  const clean = Object.fromEntries(
    Object.entries(params || {}).filter(
      ([, v]) => v !== undefined && v !== null && v !== ""
    )
  );
  return new URLSearchParams(clean).toString();
};

export async function tutoring_threads(params = {}) {
  const qs = toQs(params);
  try {
    const res = await fetch(`${base}/tutoring-threads${qs ? `?${qs}` : ""}`);
    return await res.json();
  } catch (e) {
    return { status: false, message: e.message, data: [] };
  }
}

export async function tutoring_thread(id) {
  try {
    const res = await fetch(`${base}/tutoring-thread?id=${id}`);
    return await res.json();
  } catch (e) {
    return { status: false, message: e.message };
  }
}

export async function tutoring_reply(payload) {
  try {
    const res = await fetch(`${base}/tutoring-reply`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    if (data?.status) toast.success(data?.message);
    else toast.error(data?.message);
    return data;
  } catch (e) {
    toast.error(e.message);
    return { status: false, message: e.message };
  }
}

export async function tutoring_thread_status(id, status) {
  try {
    const res = await fetch(`${base}/tutoring-thread-status?id=${id}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status }),
    });
    const data = await res.json();
    if (data?.status) toast.success(data?.message);
    else toast.error(data?.message);
    return data;
  } catch (e) {
    toast.error(e.message);
    return { status: false, message: e.message };
  }
}

export async function upload_attachment(file) {
  try {
    const fd = new FormData();
    fd.append("file", file);
    const res = await fetch(`${base}/upload-attachment`, {
      method: "POST",
      body: fd,
    });
    const data = await res.json();
    if (!data?.status) toast.error(data?.message || "Upload failed");
    return data;
  } catch (e) {
    toast.error(e.message);
    return { status: false, message: e.message };
  }
}
